import type {
  Channel,
  Context,
  ContextHandler,
  DisplayMetadata,
  Listener,
} from '@finos/fdc3';
import type { SubscriptionManager } from './subscription';
import { AgentWebSocket } from './websocket';

/**
 * the Channel class
 */
export class ConnectifiChannel implements Channel {
  constructor(
    private ws: Pick<AgentWebSocket, 'action' | 'request'>,
    private subManager: SubscriptionManager,
    public readonly id: string,
    public readonly type: Channel['type'],
    public readonly displayMetadata?: DisplayMetadata,
  ) {}

  async broadcast(context: Context): Promise<void> {
    return this.ws.request('broadcast', { context, channel: this.id });
  }

  async getCurrentContext(contextType?: string): Promise<Context | null> {
    const result = await this.ws.request('getCurrentContext', {
      channel: this.id,
      contextType,
    });
    return result.context;
  }

  addContextListener(handler: ContextHandler): Promise<Listener>;

  addContextListener(
    contextType: string | null,
    handler: ContextHandler,
  ): Promise<Listener>;

  async addContextListener(
    contextTypeOrHandler: string | null | ContextHandler,
    handlerSecondArg?: ContextHandler,
  ): Promise<Listener> {
    const handler: ContextHandler =
      typeof contextTypeOrHandler === 'function'
        ? contextTypeOrHandler
        : handlerSecondArg!;
    const contextType: string =
      typeof contextTypeOrHandler === 'string' ? contextTypeOrHandler : '*';

    await this.ws.request('addContextListener', {
      contextType: contextType,
      channel: this.id,
    });

    return this.subManager.createContextListener(
      this.ws,
      contextType,
      this.id,
      handler,
    );
  }
}
